import { render, staticRenderFns } from "./side-nav.vue?vue&type=template&id=c0ba7ae0&"
import script from "./side-nav.vue?vue&type=script&lang=js&"
export * from "./side-nav.vue?vue&type=script&lang=js&"
import style0 from "./side-nav.vue?vue&type=style&index=0&id=c0ba7ae0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports